<template>
  <div>
    <div v-if="countdown.finished" role="alert">
      <div v-html="$translate('Bigtex5::Template.deliveryNextWorkingDay')"></div>
    </div>
    <div v-else>
      <div v-html="$translate('Bigtex5::Template.deliveryTimer', { hour: countdown.hours, minutes: countdown.minutes })"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      finished: false
    };
  },
  mounted() {
    this.createCountDown();
  },
  methods: {
    getNoDeliveryDates() {
      const myDate = new Date();
      const myDateString = ('0' + myDate.getDate()).slice(-2) + '.' +
          ('0' + (myDate.getMonth() + 1)).slice(-2) + '.' +
          myDate.getFullYear();
      return App.noDelDates.indexOf(myDateString);
    },
    createCountDown() {
      const countDownDate = new Date().setHours(15, 0);
      const now = Date.now();
      const dayInt = new Date(now).getDay();

      if (dayInt !== 6 && dayInt !== 0 && this.getNoDeliveryDates() < 0)
      {
        const intervalId = setInterval(() => {
          const now = Date.now();
          const distance = countDownDate - now;

          this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (distance < 0) {
            clearInterval(intervalId);
            this.finished = true;
          }
        }, 1000);
      } else {
        this.finished = true;
      }
    }
  },
  computed: {
    countdown() {
      return {
        days: this.days,
        hours: this.hours,
        minutes: this.minutes,
        seconds: this.seconds,
        finished: this.finished
      };
    }
  }
};
</script>


